<template>
  <div class="result-size">
    <div class="title" style="float:left">
      <div class="icon">
        <img :src="icon" alt="icon" class="icon-image" />
      </div>
      <div class="title-text">
        {{ title }}
      </div>
    </div>
    <div class="result-data">
      <span>共找到</span>
      <span class="result-num">{{ resultNum }}</span>
      <span>本图书</span>
      <template v-if="matchNum">
        <span>，共有</span>
        <span class="result-num">{{ matchNum }}</span>
        <span>个匹配条目</span>
      </template>
      <input
        class="choose-page"
        v-model.lazy="curPage"
        :placeholder="curPage"
      />/{{ pageNum }}页
      <img
        src="../assets/images/icons/pageleft.png"
        class="pagechange"
        style="margin-left: 30px;"
        @click="curPage > 1 ? curPage-- : curPage"
      />
      <img
        src="../assets/images/icons/pageright.png"
        class="pagechange"
        @click="curPage < pageNum ? curPage++ : curPage"
      />
      <span style="margin-left: 30px;">显示</span>
      <el-dropdown
        @command="handleCommand"
        class="page-select"
        trigger="hover"
      >
        <el-button class="page-select" style="border: 1px solid #707070;">
          <span style="position: relative; top: -7px;">{{ pageSize }}</span>
          <img
            src="../assets/images/icons/open.png"
            class="img"
            style="position: relative;left:5px;"
          />
        </el-button>
        <el-dropdown-menu slot="dropdown" class="dropdown-detail">
          <el-dropdown-item command="10">10</el-dropdown-item>
          <el-dropdown-item command="20">20</el-dropdown-item>
          <el-dropdown-item command="30">30</el-dropdown-item>
          <el-dropdown-item command="50">50</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBar',
  props: {
    resultNum: {
      type: Number,
      default: 0
    },
    matchNum: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: '检索结果'
    },
    icon: {
      default: require('@/assets/images/icons/book.png')
    },
    curPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      pageSize: this.pageSize,
      curPage: this.curPage
    }
  },
  methods: {
    handleCommand (command) {
      this.pageSize = parseInt(command)
      //   alert(this.pageSize)
      this.$emit('changePageSize', this.pageSize)
    }
  },
  watch: {
    curPage (val) {
      if (val > this.pageNum) this.curPage = this.pageNum
      if (val <= 0) this.curPage = 1
      this.$emit('changeCurPage', val)
    }
  }
}
</script>

<style scoped>
.result-size {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  display: flex;
  width: 156px;
  border-bottom: 1px solid #dfc6b2;
  padding: 15px 0;
  margin-left: 18px;
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-image {
  height: 20px;
  margin-left: 5px;
  margin-top: 5px;
}

.title-text {
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
  margin-left: 15px;
}

.result-data {
  font-size: 14px;
  color: #634c37;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 20px;
}

.result-num {
  color: #9e5c1d;
  margin: 0px 10px 0px 10px;
}

.choose-page {
  width: 40px;
  height: 25px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #707070;
  font-size: 16px;
  text-align: center;
  margin-right: 10px;
  margin-left: 20px;
}

.pagechange {
  width: 25px;
  height: 25px;
  background: rgba(158, 92, 29, 0);
  border-radius: 0px 0px 0px 0px;
  cursor: pointer;
    margin-right: 5px;
}

.page-select {
  width: 61px;
  height: 25px;
  text-align: left;
  border-radius: 0;
  background: #ffffff;
  color: #634c37;
  margin-left: 4px;
}
.img {
  width: 11px;
  height: 6px;
  position: relative;
  top: -9px;
}
.result-data >>> .el-button {
  font-size: 14px;
}
.el-button:hover {
  color: #9e5c1d;
  background-color: #ffffff;
  border-color: #9e5c1d;
}
.dropdown-detail >>> .el-dropdown-menu__item:hover {
  color: #9e5c1d;
  background-color: #ecded1;
  border-color: #9e5c1d;
}
.option:hover {
  background: red;
}
</style>



// WEBPACK FOOTER //
// src/components/ResultSize.vue